import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';

export const eisGuard: CanActivateFn = () => {
  const role = inject(AuthService).currentUser()?.role;
  if (
    role === 'super_admin' ||
    role === 'admin_kepala_lapas' ||
    role === 'admin_kanwil' ||
    role === 'admin_dapur'
  )
    return true;
  inject(Router).navigate(['/admin']);
  return false;
};
